export default class ADPJobs {
  constructor() {
    this.init();
  }

  init() {
    let self = this;
    let featuredJobContainer = $('.js-featured-job');
    let featuredJobsCareersContainer = $('.js-featured-jobs-careers');

    const jobsAPIURL = `${window.location.origin}/wp-json/api/v1/adpjobs`;

    if (featuredJobContainer.length) {
      $.ajax({
        url: jobsAPIURL,
        method: 'GET',
        //json 'data' is guaranteed to be an object
        dataType: 'json',
      })
        .done(function (data) {
          // sort results by date first
          data.jobRequisitions.sort((a, b) => {
            return new Date(b.postDate) - new Date(a.postDate);
          });
          // single professional job
          let latestJobObj = self.findProfessionalJob(data);
          // simplified professional job array with a single object inside
          let latestJobObjSanitized = self.sanitizeJobResult(latestJobObj);

          //   featuredJobContainer.html(`
          //     <h4 class="text-white font-medium tracking-normal text-lg lg:text-2xl mb-3 lg:mb-6">${latestJobObjSanitized[0].job_title}</h4>
          //     <a href="${latestJobObjSanitized[0].job_link}" target="_blank" class="text-white uppercase font-medium text-xs lg:text-base tracking-wider border-b-2 leading-normal inline-block border-transparent hover:border-mango-tango transition-all ease-in-out duration-300">
          //       Learn More
          //     </a>
          //   `);
        })
        .fail(function (data) {
          console.log(
            "Something wen't wrong with the insertion of the Job details from ADP.",
            data
          );
        });
    }

    if (featuredJobsCareersContainer.length) {
      $.ajax({
        url: jobsAPIURL,
        method: 'GET',
        //json 'data' is guaranteed to be an object
        dataType: 'json',
      })
        .done(function (data) {
          // sort results by date first
          data.jobRequisitions.sort((a, b) => {
            return new Date(b.postDate) - new Date(a.postDate);
          });

          // single professional job
          let latestJobObjProfessional = self.findProfessionalJob(data);
          // single craft job
          let latestJobObjCraft = self.findCraftJob(data);
          // simplified professional job array with a single object inside
          let latestJobObjProfessionalSanitized = self.sanitizeJobResult(
            latestJobObjProfessional
          );
          // simplified craft job array with a single object inside
          let latestJobObjCraftSanitized =
            self.sanitizeJobResult(latestJobObjCraft);

          // update front end with job details
          //   featuredJobsCareersContainer.html(`

          //     <div class="divide-y divide-white">
          //       <div class="py-8">
          //         <div class="text-2xl font-medium mb-5">
          //           ${latestJobObjProfessionalSanitized[0].job_title}
          //         </div>
          //         <a href="${latestJobObjProfessionalSanitized[0].job_link}" target="_blank" class="bg-mango-tango text-white inline-flex justify-center items-center text-base py-4 hover:bg-blue-prussian font-medium tracking-widest translate w-48 uppercase transition">
          //           LEARN MORE
          //         </a>
          //       </div>
          //       <div class="py-8">
          //         <div class="text-2xl font-medium mb-5">
          //           ${latestJobObjCraftSanitized[0].job_title}
          //         </div>
          //         <a href="${latestJobObjCraftSanitized[0].job_link}" target="_blank" class="bg-mango-tango text-white inline-flex justify-center items-center text-base py-4 hover:bg-blue-prussian font-medium tracking-widest translate w-48 uppercase transition">
          //           LEARN MORE
          //         </a>
          //       </div>
          //     </div>

          //   `);

          console.log('Successfully inserted ADP job!');
        })
        .fail(function (data) {
          console.log(
            "Something wen't wrong with the insertion of the Job details from ADP.",
            data
          );
        });
    }
  }

  /**
   * Finds the first Professional Job from the response given by the adpjobs API call.
   * Finding the first Professional Job means that it's the most recent one.
   * @param Array Array of objects
   * @returns A single object containing the latest professional job details.
   */
  findProfessionalJob(data) {
    // use filter instead of find to get all of the d=craft jobs available within the first 100 records ADP gives us if needed.
    return data.jobRequisitions.find((req) => {
      if (req.postingInstructions.length > 0) {
        return !req.postingInstructions[0].postingChannel.internetAddress.uri.includes(
          'd=Craft'
        );
      }
    });
  }

  /**
   * Finds the first Craft Job from the response given by the adpjobs API call.
   * Finding the first Craft Job means that it's the most recent one.
   * @param {*} data
   * @returns A single object containing the latest craft job details.
   */
  findCraftJob(data) {
    // use filter instead of find to get all of the d=craft jobs available within the first 100 records ADP gives us if needed.
    return data.jobRequisitions.find((req) => {
      if (req.postingInstructions.length > 0) {
        return req.postingInstructions.find((individualPostInstructions) => {
          // eslint-disable-next-line
          if (
            individualPostInstructions.postingChannel.hasOwnProperty(
              'internetAddress'
            )
          ) {
            return individualPostInstructions.postingChannel.internetAddress.uri.includes(
              'd=Craft'
            );
          }
        });
      }
    });
  }

  /**
   * Returns an array of an object that contains only the need data to output
   * to the FrontEnd.
   * @param object Single Job Object
   * @returns An array with a single object.
   */
  sanitizeJobResult(jobObj) {
    return [jobObj].map((item) => {
      return {
        job_title: item.requisitionTitle,
        job_link:
          item.postingInstructions[0].postingChannel.internetAddress.uri,
      };
    });
  }
}
